import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

class SortFiltersModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'sort',
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_range: [],
        filterby_vintage: []
      },
      selectedFilters: [],
      sortBy: '',
      value: { min: 0, max: 15 },
    }
    this.selectFilter = this.selectFilter.bind(this);
    this.renderSortOptions = this.renderSortOptions.bind(this);
    this.clearFilters =this.clearFilters.bind(this);
    this.updateRangeFilter = this.updateRangeFilter.bind(this);
    this.renderRange = this.renderRange.bind(this);
    this.renderVintage = this.renderVintage.bind(this);
    this.addValuesToFilter = this.addValuesToFilter.bind(this);
  }

  componentDidMount() {

    const {actionMode, sortBy, appliedFilters} = this.props;
    this.setState({
      activeTab: actionMode === 'sort'
        ? 'sort'
        : 'description',
      sortBy: sortBy,
      appliedFilters: appliedFilters
    });
  }

  componentDidUpdate(prevProps, prevState) {

    console.log("componentDidUpdate: PROPS", prevProps, this.props);
    if (prevProps.actionMode != this.props.actionMode && this.props.actionMode === 'sort')
      this.setState({ activeTab: 'sort' })

    if (prevProps.filters != this.props.filters) {
      this.addValuesToFilter();
    }
  }

  render() {

    const {visibility, actionMode, onClose} = this.props;
    console.log("SORT_FILTERS_MODAL_PROPS", this.props);
    console.log("SORT_FILTERS_MODAL_STATE", this.state);
    return (
      <div className={`sort-filters-modal ${visibility
        ? ''
        : 'hidden'}`}>
        <div onClick={() => onClose
          ? onClose()
          : null}>Close</div>
        <div className="sort-filters-container">
          {this.renderHeader()}
          {this.renderTabs()}
          {this.renderPanels()}
          {this.renderFooter()}
        </div>
      </div>
    )
  }

  renderHeader() {

    const {onClearFilters} = this.props;
    return (
      <div className="sort-filters-header">
        <div className="content-left">FILTERS BY</div>
      <div className="content-right" onClick={() => this.clearFilters()}>Clear All</div>
      </div>
    )
  }

  renderTabs() {

    const {actionMode, hideSortOptions} = this.props;
    const {activeTab} = this.state;
    return (
      <div className="tabs-container">
        <ul>
          {hideSortOptions
            ? null
            : (
              <li className={activeTab === 'sort'
                ? 'active'
                : ''} onClick={() => this.setState({activeTab: 'sort'})}>Sort</li>
            )}
          <li className={activeTab === 'description'
            ? 'active'
            : ''} onClick={() => this.setState({activeTab: 'description'})}>Descriptions</li>
          <li className={activeTab === 'range'
            ? 'active'
            : ''} onClick={() => this.setState({ activeTab: 'range' })}>Price</li>
          <li className={activeTab === 'vintage'
            ? 'active'
            : ''} onClick={() => this.setState({ activeTab: 'vintage' })}>Vintage</li>
          <li className={activeTab === 'sizes'
            ? 'active'
            : ''} onClick={() => this.setState({activeTab: 'sizes'})}>Sizes</li>
        </ul>
      </div>
    )
  }

  addValuesToFilter() {
    let maxValue=0,
        minValue = 0,
        range = {...this.state.value};
    if(this.props.filters && this.props.filters.filterby_range && this.props.filters.filterby_range.items &&
      this.props.filters.filterby_range.items[0] && this.props.filters.filterby_range.items[0]){
        maxValue = Math.round(this.props.filters.filterby_range.items[0].priceMax);
        minValue = Math.floor(this.props.filters.filterby_range.items[0].priceMin);
      }
    range.min = minValue;
    range.max = maxValue;
      this.setState({
                  value: range,
                  maxValue:maxValue,
                  minValue: minValue});
  }

  renderPanels() {

    const {activeTab, hideSortOptions} = this.state;
    return (
      <div className="panels-container">
        {activeTab === 'description'
          ? this.renderDescriptions()
          : null}
        {activeTab === 'sizes'
          ? this.renderSizes()
          : null}
        {activeTab === 'sort' && !hideSortOptions
          ? this.renderSortOptions()
          : null}
        {activeTab === 'range'
          ? this.renderRange()
          : null}
        {activeTab === 'vintage'
          ? this.renderVintage()
          : null}
      </div>
    )
  }

  renderFooter() {
    const {onClose, onApply} = this.props;
    const {appliedFilters, sortBy} = this.state;
    return (
      <div className="footer-container">
        <div className="close-button">
          <div onClick={() => onClose
            ? onClose()
            : null}>Close</div>
        </div>
        <div className="apply-button">
          <div onClick={() => onApply
            ? onApply(appliedFilters, sortBy)
            : null}>Apply</div>
        </div>
      </div>
    )
  }

  renderSizes() {

    const {filters} = this.props;
    const {appliedFilters} = this.state;
    let filterCount = filters && filters.filterby_sizes
      ? filters.filterby_sizes.items.length
      : 0;

    return (
      <div className="filter-options">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_sizes.items.map((filter, idx) => {
                let isSelected = appliedFilters.filterby_sizes.indexOf(filter._id) != -1
                //console.log("IS SELECTED", filter._id, appliedFilters.filterby_sizes.indexOf(filter._id));
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_sizes_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_sizes', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
}
      </div>
    )
  }

  renderDescriptions() {

    const {filters} = this.props;
    const {appliedFilters} = this.state;
    let filterCount = filters && filters.filterby_description
      ? filters.filterby_description.items.length
      : 0;

    return (
      <div className="filter-options">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_description.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_description.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_description_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_description', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
}
      </div>
    )
  }

  updateRangeFilter(value) {
    this.setState({ value: value });
    const max = value.max;
    const min = value.min;
    this.selectFilter('filterby_range', { _id: `${min}-${max}` });
  }

  renderVintage() {
    const { filters, appliedFilters } = this.props;
    let filterCount = filters && filters.filterby_vintage
      ? filters.filterby_vintage.items.length
      : 0;
    return (
      <div className="filter-options">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_vintage.items.map((filter, idx) => {
                let isSelected = appliedFilters.filterby_vintage && appliedFilters.filterby_vintage.indexOf(filter._id) != -1
                return filter._id && filter._id.trim()
                  ? (
                    <li key={`filterby_vintage_${filter._id}`} className={`option ${isSelected
                      ? 'active'
                      : ''}`} onClick={() => this.selectFilter('filterby_vintage', filter)}>{`${filter._id} (${filter.count})`}</li>
                  )
                  : null
              })
              }
            </ul>
          )
          : null
        }
      </div>
    );
  }

  renderRange(){
    let maxValue = 0,
      minValue = 0,
      range = { ...this.state.value };
    if (this.props.filters && this.props.filters.filterby_range && this.props.filters.filterby_range.items &&
      this.props.filters.filterby_range.items[0] && this.props.filters.filterby_range.items[0]) {
      maxValue = Math.round(this.props.filters.filterby_range.items[0].priceMax);
      minValue = Math.floor(this.props.filters.filterby_range.items[0].priceMin);
    }
    range.min = minValue;
    range.max = maxValue;
    return(
      <div className="range-filter">
        <InputRange
          draggableTrack
          maxValue={maxValue}
          minValue={minValue}
          step={1}
          formatLabel={value => `$${value}`}
          value={this.state.value}
          onChange={this.updateRangeFilter}
        />
      </div>
    );
  }

  renderSortOptions() {

    const {sortBy} = this.state;
    return (
      <div className="filter-options">
        <ul>
          <li className={`option ${sortBy === 'name_asc'
            ? 'active'
            : ''}`} onClick={() => this.setState({sortBy: 'name_asc'})}>{'Name: A to Z'}</li>
          <li className={`option ${sortBy === 'name_desc'
            ? 'active'
            : ''}`} onClick={() => this.setState({sortBy: 'name_desc'})}>{'Name: Z to A'}</li>
          <li className={`option ${sortBy === 'price_asc'
            ? 'active'
            : ''}`} onClick={() => this.setState({sortBy: 'price_asc'})}>{'Price: Low to High'}</li>
          <li className={`option ${sortBy === 'price_desc'
            ? 'active'
            : ''}`} onClick={() => this.setState({sortBy: 'price_desc'})}>{'Price: High to Low'}</li>
        </ul>
      </div>
    )
  }

  selectFilter(type, filter) {

    const {appliedFilters} = this.state;
    let modifiedFilters = this.state.appliedFilters;
    let selectedFilters = this.state.selectedFilters;
    let modifiedFilter = Object.assign({}, filter);
    modifiedFilter['type'] = type;

    if (type === DEFAULT_FILTERS.filterby_range.id) {
      selectedFilters.forEach(function (value, index) {
        if (value.type === type) {
          selectedFilters.splice(index, 1);
        }
      })
      modifiedFilters[type] = [];
    }
    
    if (!modifiedFilters[type])
      modifiedFilters[type] = [];
    if (modifiedFilters[type].indexOf(filter._id) < 0)
      modifiedFilters[type].push(filter._id);
    else
      modifiedFilters[type].splice(modifiedFilters[type].indexOf(filter._id), 1);

    this.setState({appliedFilters: modifiedFilters})
  }

  clearFilters() {

      const {onClearFilters} = this.props;
      this.setState({appliedFilters: {
        filterby_sizes: [],
        filterby_description: []
      }}, () => {
        if(onClearFilters) onClearFilters();
      })
      this.addValuesToFilter();
  }
}

const DEFAULT_FILTERS = {
  filterby_range: {
    id: 'filterby_range',
    name: 'Range',
    index: 'PriceB',
    itemType: 'Range',
    items: [],
    products: {}
  }
}

export default SortFiltersModal;



// WEBPACK FOOTER //
// ./src/components/commons/modals/SortFiltersModal.js